// US states and US timezones — reused across Leads filter, Lead create form, etc.

export const US_STATES = [
  { code: 'AL', name: 'Alabama' }, { code: 'AK', name: 'Alaska' },
  { code: 'AZ', name: 'Arizona' }, { code: 'AR', name: 'Arkansas' },
  { code: 'CA', name: 'California' }, { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' }, { code: 'DE', name: 'Delaware' },
  { code: 'DC', name: 'District of Columbia' }, { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' }, { code: 'HI', name: 'Hawaii' },
  { code: 'ID', name: 'Idaho' }, { code: 'IL', name: 'Illinois' },
  { code: 'IN', name: 'Indiana' }, { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' }, { code: 'KY', name: 'Kentucky' },
  { code: 'LA', name: 'Louisiana' }, { code: 'ME', name: 'Maine' },
  { code: 'MD', name: 'Maryland' }, { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' }, { code: 'MN', name: 'Minnesota' },
  { code: 'MS', name: 'Mississippi' }, { code: 'MO', name: 'Missouri' },
  { code: 'MT', name: 'Montana' }, { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' }, { code: 'NH', name: 'New Hampshire' },
  { code: 'NJ', name: 'New Jersey' }, { code: 'NM', name: 'New Mexico' },
  { code: 'NY', name: 'New York' }, { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' }, { code: 'OH', name: 'Ohio' },
  { code: 'OK', name: 'Oklahoma' }, { code: 'OR', name: 'Oregon' },
  { code: 'PA', name: 'Pennsylvania' }, { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' }, { code: 'SD', name: 'South Dakota' },
  { code: 'TN', name: 'Tennessee' }, { code: 'TX', name: 'Texas' },
  { code: 'UT', name: 'Utah' }, { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' }, { code: 'WA', name: 'Washington' },
  { code: 'WV', name: 'West Virginia' }, { code: 'WI', name: 'Wisconsin' },
  { code: 'WY', name: 'Wyoming' },
  { code: 'PR', name: 'Puerto Rico' }, { code: 'VI', name: 'U.S. Virgin Islands' },
  { code: 'GU', name: 'Guam' }, { code: 'AS', name: 'American Samoa' },
  { code: 'MP', name: 'Northern Mariana Islands' },
];

export const US_TIMEZONES = [
  { id: 'America/New_York',     label: 'Eastern (ET) — New York' },
  { id: 'America/Detroit',      label: 'Eastern (ET) — Detroit' },
  { id: 'America/Indiana/Indianapolis', label: 'Eastern (ET) — Indianapolis' },
  { id: 'America/Chicago',      label: 'Central (CT) — Chicago' },
  { id: 'America/Indiana/Knox', label: 'Central (CT) — Knox, IN' },
  { id: 'America/Menominee',    label: 'Central (CT) — Menominee, MI' },
  { id: 'America/North_Dakota/Beulah', label: 'Central (CT) — Beulah, ND' },
  { id: 'America/Denver',       label: 'Mountain (MT) — Denver' },
  { id: 'America/Boise',        label: 'Mountain (MT) — Boise' },
  { id: 'America/Phoenix',      label: 'Mountain (MST, no DST) — Phoenix' },
  { id: 'America/Los_Angeles',  label: 'Pacific (PT) — Los Angeles' },
  { id: 'America/Anchorage',    label: 'Alaska (AKT) — Anchorage' },
  { id: 'America/Juneau',       label: 'Alaska (AKT) — Juneau' },
  { id: 'America/Nome',         label: 'Alaska (AKT) — Nome' },
  { id: 'America/Adak',         label: 'Hawaii–Aleutian (HAST) — Adak' },
  { id: 'Pacific/Honolulu',     label: 'Hawaii (HST, no DST) — Honolulu' },
  { id: 'America/Puerto_Rico',  label: 'Atlantic (AST) — Puerto Rico' },
  { id: 'America/St_Thomas',    label: 'Atlantic (AST) — U.S. Virgin Islands' },
  { id: 'Pacific/Guam',         label: 'Chamorro (ChST) — Guam' },
  { id: 'Pacific/Pago_Pago',    label: 'Samoa (SST) — American Samoa' },
];
